import { AiFillYoutube } from "react-icons/ai";
import twig_component from "./img/twig_component.png";
import voter_symfony from "./img/voter_symfony.png";
import dataprovider from "./img/provider.png";
import mailer from "./img/mailer-video.png";
import oauth_github from "./img/oauth_github.png";
import api_upload from "./img/api-upload.png";
import notification_push from "./img/notification_push.png";
import cpanel_symf from "./img/cpanel_symf.png";
import turborepo from "./img/turbo-repo.png";
import multi_base from "./img/multi-base.png";
import authentification_multi_base from "./img/authentification_multi_base.jpg";
import fakerphp_generate_data from "./img/fakerphp_generate_data.png";
import "./Youtube.css"; // Import du fichier CSS

const Youtube = () => {
  const tutorials = [
    {
      title: "Installation Symfony avec TurboRepo",
      img: turborepo,
      link: "https://youtu.be/Gx9AwHvjsF8",
      description:
        "📌 Très intéressant pour   \n" +
        "✅ les projets SaaS \n" +
        "✅ les architectures modulaires \n" +
        "✅ les équipes fullstack \n" +
        "✅ les plateformes multi-applications \n" 
    },
    {
      title: "(Part 2) Ajout authentification pour un multi-base en symfony",
      img: authentification_multi_base,
      link: "https://youtu.be/AfnlPmYZMDc",
      description:
        "📌 Ce que vous trouverez dans ce video  \n" +
        "✅ Modification de security.yaml \n" +
        "✅ Creation de service pour gerer la security dans page dynamique \n" +
        "✅ Création de UserDynamicAuthenticator pour personaliser l'authentification dynamic. \n" +
        "✅ Création de commande pour remplir automatique la table utilisateur \n" 
    },
    {
      title: "(Part 1) Créer un système Multi-Base de Données avec Symfony & MySQL – Tutoriel complet",
      img: multi_base,
      link: "https://www.youtube.com/watch?v=jAr8O1ZFd4k&pp=2AaRBg%3D%3D",
      description:
        "📌 Ce que vous trouverez dans ce video  \n" +
        "✅ Créer une base principale \n" +
        "✅ Générer et connecter des bases secondaires selon les besoins de l'utilisateur \n" +
        "✅ Mettre en place un choix de base au moment de la connexion \n" +
        "✅ Configurer Symfony pour changer de connexion à la volée \n" +
        "✅ Créer automatiquement les entités, schémas et utilisateurs pour chaque site \n" +
        "✅ Utiliser les services Symfony, Doctrine et les événements pour rendre tout dynamique \n" 
    },
    {
      title: "Notification push avec symfony",
      img: notification_push,
      link: "https://youtu.be/ULJVlGtxxgI",
      description:
        "📌 Ce que vous trouverez dans ce video  \n" +
        "✅ Configuration de Symfony pour gérer les notifications \n" +
        "✅ Mise en place du Service Worker \n" +
        "✅ Génération des clés VAPID \n" +
        "✅ Enregistrement du navigateur \n" +
        "✅ Envoi d’une notification depuis Symfony \n" +
        "✅ Tests et exemples concrets"
    },

    {
      title: "Mettre en production un projet Symfony sur cPanel sans SSH",
      img: cpanel_symf,
      link: "https://www.youtube.com/watch?v=xPmgHXA4qPI",
      description:
        "📌 Ce que vous trouverez dans ce video  \n" +
        "✅ Comment créer un projet Symfony \n" +
        "✅ Comment le déployer sur cPanel sans utiliser SSH \n" +
        "✅ Comment effectuer correctement les configurations MySQL / base de données \n" +
        "✅ Et comment faire en sorte que le projet fonctionne en production facilement \n" 
    },
    {
      title: "Api pour generer data avec FakerPHP",
      img: fakerphp_generate_data,
      link: "https://www.youtube.com/watch?v=bcR93MiLq9U",
      description:
        "Dans cet tuto, je vous montre comment generer automatique une information d'une personne si on ne veut pas qu'on saisit les information."+
        "Ceci est éfficace pour remplir automatique les champs formulaire pour test." 
    },
    {
      title: "Upload file avec API Platform",
      img: api_upload,
      link: "https://www.youtube.com/watch?v=5tLFZOgRysU",
      description:
        "📌 Ce que vous allez apprendre  \n" +
        "✅ Installation et configuration de VichUploaderBundle \n" +
        "✅ Gestion du stockage des fichiers (local ou distant) \n" +
        "✅ Création d'une entité avec un champ de fichier \n" +
        "✅ Intégration avec API Platform pour exposer l'upload via une API \n" +
        "✅ Bonnes pratiques pour sécuriser et optimiser le processus"
    },
    {
      title: "Création du menu en Symfony utilisant twig-component",
      img: twig_component,
      link: "https://www.youtube.com/watch?v=2VChHj63OLY",
      description:
        "Un twig-component est une approche permettant de créer des composants réutilisables dans des fichiers Twig, facilitant la gestion des interfaces utilisateur dans des projets Symfony."
    },
    {
      title: "Ajout du voter pour la sécurité de l'application",
      img: voter_symfony,
      link: "https://www.youtube.com/watch?v=0MNXXqjUIro",
      description:
        "Un voter dans Symfony permet de gérer les droits d'accès en décidant si un utilisateur peut effectuer une action spécifique sur une ressource."
    },
    {
      title: "Utilisation de DataProvider dans API Platform",
      img: dataprovider,
      link: "https://www.youtube.com/watch?v=W4CVWiNIyRI",
      description:
        "Un DataProvider dans API Platform permet de personnaliser la manière dont les données sont récupérées pour les ressources exposées dans l'API."
    },
    {
      title: "Symfony Mailer avec GMail",
      img: mailer,
      link: "https://www.youtube.com/watch?v=qIus83MuLhw",
      description:
        "Symfony Mailer est un composant de Symfony qui permet d'envoyer des emails de manière simple et efficace."
    },
    {
      title: "Utilisation de OAuth pour Github",
      img: oauth_github,
      link: "https://www.youtube.com/watch?v=U5wbRDK3MUI",
      description:
        "OAuth (Open Authorization) est un protocole d'autorisation qui permet à une application d’accéder aux ressources d’un utilisateur sur un autre service, sans exposer ses identifiants (comme son mot de passe)."
    },
    
    
  ];

  return (
    <div className="projet" id="tutoriel">
      <div className="title">TUTORIEL SUR YOUTUBE</div>
      <div className="react_content">
        {tutorials.map((tutorial, index) =>
          <div id="react_div" key={index}>
            <div className="title_projet">
              {tutorial.title}
            </div>
            <a target="_blank" rel="noopener noreferrer" href={tutorial.link}>
              <img id="react" src={tutorial.img} alt={"antonio navira " + tutorial.title} />
            </a>
            <ul>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  id="react_link"
                  href={tutorial.link}
                >
                  Voir <b>youtube</b> <AiFillYoutube />
                </a>
              </li>
              <li>
                <div id="description_bpm">Description du sujet</div>
                <div id="description_bpm_txt">
                  {tutorial.description.split("\n").map((line, index) =>
                    <p key={index}>
                      {line}
                    </p>
                  )}
                </div>
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default Youtube;
